<template>
  <main v-if="!isLoading">
    <organism-alert-modification
      :mode="mode"
      :alertData="alertData"
      :notificationData="notificationData"
      :equipmentData="equipmentData"
      @createAlert="createAlert"
      @editAlert="updateAlert"
      @deleteAlert="deleteAlert"
    ></organism-alert-modification>
  </main>
</template>

<script>
import OrganismAlertModification from "@/components/organisms/OrganismAlertModification.vue"
import {
  getAlertManagementById,
  getAlertManagementEquipment,
  addAlertManagement,
  updateAlertManagementById,
  deleteAlertManagementById
} from "@/api/api-module"
import mixins from "@/mixins"
export default {
  name: "AlertModification",
  components: {
    OrganismAlertModification,
  },
  mixins: [mixins],
  data() {
    return {
      mode: "",
      alertData: null,
      notificationData: null,
      equipmentData: [],
      alertEquipment: null,
    }
  },
  computed: {
    isLoading() {
      return (
        !this.alertData || !this.notificationData || !this.equipmentData.length
      )
    },
  },
  created() {
    this.mode = this.$route.path === "/server-management/alert/create" ? "create" : "edit"
  },
  mounted() {
    if (this.mode === "edit") {
      this.getAlertDetail(this.$route.params.id)
    } else {
      this.alertData = {}
      this.notificationData = {
        email: [],
        sms: [],
        line: [],
      }
      this.getEquipment()
    }
  },
  methods: {
    // get alert detail
    async getAlertDetail(id) {
      this.showLoading(true)
      await getAlertManagementById(id).then((response) => {
        this.alertData = {
          alertId: response.alertId,
          alertName: response.alertName,
          alertDescription: response.alertDescription,
          alertGateway: response.alertSMSGatewayPath,
          alertEnable: response.alertEnable,
          alertEnableThreshold: response.alertThresholdEnable,
          intervalThreshold: response.alertThresholdInterval,
          maximumAlertCount: response.alertMaxEventCount,
        }
        this.notificationData = {
          email: response.alertEmails,
          sms: response.alertSmses,
          line: response.alertLines,
        }
        this.alertEquipment = response.alertEquipments
        this.getEquipment()
      }).finally(() => this.showLoading(false))
    },

    // get equipment resource
    async getEquipment() {
      this.showLoading(true)
      this.equipmentData = []
      await getAlertManagementEquipment().then((response) => {
        response.forEach((equipment) => {
          let check = equipment
          if (this.mode === "edit") {
            check = this.alertEquipment.filter((alertEquipment) => {
              return alertEquipment.equipmentId === equipment.equipmentId
            })[0]
          }

          this.equipmentData.push({
            id: equipment.equipmentId,
            nameServer: equipment.equipmentName,
            cpu: {
              isDisable: !equipment.resourceType?.cpu?.policyEnable,
              isSelect:
                this.mode === "edit"
                  ? check.resourceType?.cpu?.alertEnable
                  : equipment.resourceType?.cpu?.alertEnable,
              warningValue: equipment.resourceType?.cpu?.warningThreshold,
              criticalValue: equipment.resourceType?.cpu?.criticalThreshold,
            },
            memory: {
              isDisable: !equipment.resourceType?.memory?.policyEnable,
              isSelect:
                this.mode === "edit"
                  ? check.resourceType?.memory?.alertEnable
                  : equipment.resourceType?.memory?.alertEnable,
              warningValue: equipment.resourceType?.memory?.warningThreshold,
              criticalValue: equipment.resourceType?.memory?.criticalThreshold,
            },
            storage: {
              isDisable: !equipment.resourceType?.storage?.policyEnable,
              isSelect:
                this.mode === "edit"
                  ? check.resourceType?.storage?.alertEnable
                  : equipment.resourceType?.storage?.alertEnable,
              warningValue: equipment.resourceType?.storage?.warningThreshold,
              criticalValue: equipment.resourceType?.storage?.criticalThreshold,
            },
          })
        })
      }).finally(() => this.showLoading(false))
    },

    // create alert
    async createAlert(request) {
      this.showLoading(true)

      const response = await addAlertManagement(request)

      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess("Alert added successfully")
        this.$router.push("/server-management/alert")
      } else {
        this.toastError("Alert added failed")
      }
    },

    // update alert by id
    async updateAlert(request) {
      this.showLoading(true)

      const response = await updateAlertManagementById(this.$route.params.id, request)
      
      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess("Alert updated successfully")
        this.$router.push("/server-management/alert")
      } else {
        this.toastError("Alert updated failed")
      }
    },

    // delete alert by id
    async deleteAlert() {
      this.showLoading(true)

      const response = await deleteAlertManagementById(this.$route.params.id)
      
      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess("Alert deleted successfully")
        this.$router.push("/server-management/alert")
      } else {
        this.toastError("Alert deleted failed")
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
